<template>
  <Modal closable>
    <template v-if="feature == 'LIVE_MODE'">
      <h2>Live ruter <span class="plan-tag" style="font-size:1rem!important;">PLUS</span> </h2>
      <img src="/img/paywall_live.png" style="width:100%" />
      <h2>Lad familie og venner følge jeres rute med <b>Live ruter</b></h2>
      <p>Få mere tid til det vigtige. Spar forældres og studenters tid ved at lade chaufføren kommunikere vognens placering. Lad pårørende se forventede ankomsttider i realtid.</p>
      <p><small>PS: Det koster jer ikke mere end en flaske slave vodka 😉</small></p>
    </template>
    <template v-else>
      <h2>Get Pro!</h2>
      <p>You are not pro :/</p>
    </template>

    <template v-slot:footer>
      <AppButton color="primary" @click="proceed()">Opgradér for kun 49 kr</AppButton>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import router from '@/router'
import { store } from '@/store'


export default defineComponent({
  components: { },
  name: 'PayWall',
  props: {
    feature: String as PropType<'LIVE_MODE'>
  },
  setup(props) {

    function proceed() {
      store.modal.hideModal('PayWall')
      router.push('/account')
    }
    
    return { proceed }
  }
})
</script>

<style>

</style>